import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Slide,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface PopupProps {
  onClose: () => void;
  isOpen: boolean;
}

const CompanyUnlockFailurePopup: React.FC<PopupProps> = ({
  onClose,
  isOpen,
}) => {
  const [countdown, setCountdown] = React.useState(5);
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    timerRef.current = setTimeout(() => {
      onClose();
      window.location.reload();
    }, 5000);

    return () => {
      clearInterval(intervalRef.current!);
      clearTimeout(timerRef.current!);
    };
  }, [onClose]);

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-handle-confirm"
      PaperProps={{
        sx: {
          width: {
            xs: '370px',
            sm: '370px',
            md: '499px',
            lg: '820px',
            xl: '820px',
          },
          maxWidth: '627px !important',
          backgroundImage:
            'url("/static/companyUnlock/frame_bg_img.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'auto',
          }}
        >
          <Box>
            <img
              src="/static/companyUnlock/failure.gif"
              alt="investor"
              style={{
                width: '120px',
                height: '120px',
                padding: '-10px',
                margin: '-10px',
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#F00',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                animation: 'moveText 3s linear infinite',
                textAlign: 'center',
              }}
            >
              Issue in accessing data
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Hello there! 👋
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              We're currently experiencing some difficulties in unlocking the
              data you requested. This hiccup could be due to a variety of
              reasons, and we want you to know that our team is diligently
              looking into it.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              While we work on resolving this, you may consider exploring
              services from other companies in the meantime. We truly appreciate
              your understanding and patience.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Rest assured, we'll revert back to you as soon as we have an
              update.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Thank you for your continued support! 🌟
            </Typography>
                  </Box>
                  <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '16px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#FF0000',
                textAlign: 'center',
              }}
            >
            Closing in {countdown} seconds...
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyUnlockFailurePopup;
